import React, {
   createContext,
   PropsWithChildren,
   useContext,
   useRef
} from 'react'

import RecordWisePipelinesStore from '../../stores/RecordWisePipelinesStore'

const RecordWisePipelinesStoreContext = createContext<RecordWisePipelinesStore | null>(
   null
)

export const RecordWisePipelinesStoreProvider = (
   props: PropsWithChildren
): React.ReactElement => {
   const storeRef = useRef(RecordWisePipelinesStore.create())

   return (
      <RecordWisePipelinesStoreContext.Provider value={storeRef.current}>
         {props.children}
      </RecordWisePipelinesStoreContext.Provider>
   )
}

export const useRecordWisePipelinesStore = (): RecordWisePipelinesStore => {
   const store = useContext(RecordWisePipelinesStoreContext)

   if (!store) {
      throw new Error(
         'Expected  be used within a RecordWisePipelinesStoreProvider'
      )
   }

   return store
}
